import { useReducer } from 'react';
import { VehicleType } from '../common/CommonTypes';
import {
    VehicleContextState,
    VehicleState
} from '../../context/VehicleContext';

export type Action =
    | { type: 'set-vehicles'; vehicles: VehicleType[] }
    | { type: 'set-selected-vehicle'; selectedIndex: number };

const VehicleReducer = (state: VehicleState, action: Action) => {
    switch (action.type) {
        case 'set-vehicles': {
            return {
                ...state,
                vehicles: action.vehicles,
                selectedVehicleIndex: -1
            };
        }
        case 'set-selected-vehicle': {
            return {
                ...state,
                selectedVehicleIndex: action.selectedIndex
            };
        }
        default: {
            return state;
        }
    }
};

function useVehicleTypes(initialState?: VehicleState): VehicleContextState {
    if (initialState === undefined) {
        initialState = {
            vehicles: [],
            selectedVehicleIndex: -1
        };
    }

    const [vehicleTypes, dispatch] = useReducer(VehicleReducer, initialState);

    const { vehicles, selectedVehicleIndex } = vehicleTypes;

    const setVehicles = (vehicles: VehicleType[]): void => {
        dispatch({ type: 'set-vehicles', vehicles });
    };

    const setSelectedVehicle = (selectedIndex: number): void => {
        dispatch({ type: 'set-selected-vehicle', selectedIndex });
    };

    return {
        vehicles,
        selectedVehicleIndex,
        setVehicles,
        setSelectedVehicle
    };
}

export default useVehicleTypes;
